import { createFileRoute, redirect } from '@tanstack/react-router';

// Crew Members was folded into Technicians. The in-app crew-members list is
// backed by scheduler technicians and already links to /dashboard/technicians/$id,
// so the `$userId` param is the technician id. Redirect the deprecated detail
// route to the technician detail instead of leaving users in the old flow.
export const Route = createFileRoute('/_dashboard/dashboard/crewmember/$userId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/technicians/$id',
      params: { id: params.userId },
    });
  },
});
